import { Component, Output, EventEmitter, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { SessionStorageService } from '@shared/services';

@Component({
  selector: 'select-list-popup',
  templateUrl: './select-list-popup.component.html',
  styleUrls: [
      '../../../styles/modules/custom-popup.sass',
      './select-list-popup.component.sass'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SelectListPopup implements OnChanges {
  @Input() entries:     any[];
  @Input() popupClass:  string;
  @Input() checkbox:    boolean;
  @Input() active:      any;

  @Input() reload:      boolean;
  @Input() searchQuery: boolean;

  @Input() page:        number;
  @Input() totalPages:  number;

  @Input() searchValue: string;
  @Input() searchTimer: ReturnType<typeof setTimeout>;

  @Output() itemCallback       = new EventEmitter<any>();
  @Output() paginationCallback = new EventEmitter<any>();
  @Output() closeCallback      = new EventEmitter<void>();
  private readonly COMPONENT_NAME: string = 'SelectListPopup';
  constructor( private sessionStorageService: SessionStorageService ) {
    this.searchValue = this.searchValue;
    setTimeout(() => {
      if (this.searchQuery) {
        let el = document.getElementById('select-list-search');
        el.focus();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.checkbox && this.active) this.parceCheckbox();
  }

  private parceCheckbox(): void {
    this.active.split(';').forEach(el => {
      let entrie = this.entries.find(e => e.id === +el.split('_')[0]);
      if (entrie) entrie.active = true;
    });
  }

  selectItem(value): void {
    if (!this.checkbox) {
      this.itemCallback.emit(value);
      this.closePopup();
    }
  }

  paginationHandler(page: number): void {
    this.pagination(page, this.searchValue);
  }

  pagination(page: number, search: string, searchQuery: boolean = null): void {
    this.paginationCallback.emit({ page, search, searchQuery,
      active: this.collectCheckbox()
    });
  }

  closePopup(e = null): void {
    if (!e || !e.target.closest('.custom-popup-wrapper')) {
      this.closeCallback.emit();
      clearTimeout(this.searchTimer);
      if (this.checkbox) this.handleCheckboxs();
      this.sessionStorageService.popDynamicComponent(this.COMPONENT_NAME);
    }
  }

  private collectCheckbox(): any {
    let activeItems = new Set(this.entries.filter(e => e.active).map(e => `${e.id}_${e.label}`));
    if (this.active) this.active.split(';').filter(e => !this.entries.find(l => l.id === +e.split('_')[0])).forEach(e => activeItems.add(e));
    return [...activeItems].join(';');
  }

  private handleCheckboxs(): void {
    let newItems = this.collectCheckbox();
    this.itemCallback.emit(newItems);
  }

  changeSearchValue(query: string): void {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => this.pagination(1, query, true), 1000);
  }

  clearSearch(): void {
    this.searchValue = '';
    this.pagination(1, this.searchValue);
  }

}
